import config from '../config.json';

export default function fetchFilters(embedfilter_id) {
  return fetch(
    [config.url, config.api.base, config.api.version, config.api.endpoints.filters].join('/')+'?embedfilter_id='+embedfilter_id+'&lang_code='+localStorage.getItem("locale"),
    {method: 'GET'}
  );
}
